$(function () {
    // 1. GLOBAL AUTO-PLAY ON LOAD
    function autoPlayMainVideo() {
        const firstWrapper = $(".banner-home_video, .video-wrapper").first();
        const video = firstWrapper.find("video")[0];
        const poster = firstWrapper.find(".poster, .banner-poster")[0];
        const playBtn = firstWrapper.find(".play-btn")[0];

        if (video) {
            // Create and add loader
            const loader = $('<div class="video-loader"></div>');
            $(firstWrapper).append(loader);

            // Mute for browser compliance
            video.muted = true; 
            video.setAttribute('autoplay', '');
            video.setAttribute('playsinline', '');

            // Hide play btn/poster and show video when it starts playing
            video.addEventListener("playing", () => {
                loader.remove(); // Remove loader
                if (poster) poster.style.display = "none";
                if (playBtn) playBtn.style.display = "none";
                video.style.display = "block";
            });

            video.play().catch(error => {
                console.log("Autoplay blocked. User interaction required.");
                loader.remove();
            });
        }
    }

    autoPlayMainVideo(); // Run on load

    // --- YOUR EXISTING CODE (Slightly improved) ---
    function playVideo(wrapper, playBtn, poster, video) {
        $("video").each(function () {
            this.pause();
            this.currentTime = 0;
            this.style.display = "none";
        });
        $(".poster, .banner-poster").show();
        $(".play-btn").show();

        if (poster) poster.style.display = "none";
        if (playBtn) playBtn.style.display = "none";
        video.style.display = "block";
        video.play();
    }

    $(".banner-home_video, .video-wrapper").each(function () {
        const wrapper = $(this);
        const playBtn = wrapper.find(".play-btn")[0];
        const video   = wrapper.find("video")[0]; 
        const poster  = wrapper.find(".poster, .banner-poster")[0];

        if(playBtn) {
            playBtn.addEventListener("click", () => {
                playVideo(wrapper, playBtn, poster, video);
            });
        }

        if(video) {
            video.addEventListener("ended", () => {
                if (poster) poster.style.display = "block";
                if (playBtn) playBtn.style.display = "flex";
                video.style.display = "none"; 
            });
        }
    });
});
